import { IAssistantConfig, IDiscountConfig, IPricingRuleDiscount } from '../types';
import { applyMarginToConfiguration } from './applyMargin';

export const transformConfigurationPricing = (
    configuration: IAssistantConfig | undefined,
    marginPercentage: number,
    discountConfig?: IDiscountConfig,
    pricingRuleDiscounts?: IPricingRuleDiscount[],
): IAssistantConfig | undefined => {
    if (!configuration) return configuration;
    return applyMarginToConfiguration(configuration, marginPercentage, discountConfig, pricingRuleDiscounts);
};
